export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-04b_DE.76c11ca9.png";